import React from 'react'

export default () => {
  return (
    <footer>
      <div>
        <h2> © 2021 Popapp </h2>
        <h3> Arteveldehogeschool, opleiding Grafische en digitale media </h3>
      </div>
    </footer>
  )
}
